// extracted by mini-css-extract-plugin
module.exports = {"section":"notification_section__pyh3l","skewed":"notification_skewed__36yL6"};